"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("core.ui-module_site-components");
var _ApplicationContext = require("../../api/ApplicationContext");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SITE_NAME = _ApplicationContext.ApplicationContext.getSiteName() ? _ApplicationContext.ApplicationContext.getSiteName() : '[SITE NAME HERE]';
class SiteMaintenance extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      isShow: props.isShow,
      closeModal: props.closeModal
    };
  }
  toggleShow(isShow) {
    this.setState({
      isShow
    });
  }
  render() {
    const {
      isShow,
      closeModal
    } = this.state;
    const modalRoot = document.getElementById('modal-root');
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("a", {
      onClick: () => {
        this.toggleShow(true);
      },
      className: ""
    }, "Site Maintenance Schedule"), isShow && /*#__PURE__*/_react.default.createElement(_core.Modal, {
      header: "Site Maintenance Schedule",
      footer: /*#__PURE__*/_react.default.createElement("div", null),
      closeModalCallback: () => {
        if (typeof closeModal !== 'undefined') {
          closeModal();
        } else {
          this.toggleShow(false);
        }
      },
      portalContainer: modalRoot
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", {
      align: " justify"
    }, "MissionSquare Retirement must periodically perform maintenance on our website to keep it running at peak performance."), "Current maintenance schedule", /*#__PURE__*/_react.default.createElement("p", {
      align: " justify"
    }, "Sundays 4:00 a.m. to 12:00 p.m. Eastern Time"), /*#__PURE__*/_react.default.createElement("p", {
      align: " justify"
    }, "During the maintenance window, the site may have fewer features available. On rare occasions, the sites may be unavailable or experience intermittent availability during the maintenance period. Periodically the maintenance may be extended without prior notice from 12:00 a.m. ET to 12:00 p.m. ET. However, participants can log in and check their balances during the extended maintenance window."), /*#__PURE__*/_react.default.createElement("p", {
      align: " justify"
    }, SITE_NAME, " is normally available 24 hours a day, seven days a week for your convenience except during scheduled maintenance periods. However, service availability is not guaranteed. Neither MissionSquare Retirement and its affiliates nor the Trust will be responsible for any loss (or foregone gain) you may incur as a result of the service being unavailable."), /*#__PURE__*/_react.default.createElement("p", {
      align: " justify"
    }, "Thank you for entrusting us with your online transactions."))));
  }
}
exports.default = SiteMaintenance;
SiteMaintenance.propTypes = {
  isShow: _propTypes.default.bool,
  closeModal: _propTypes.default.func
};
SiteMaintenance.defaultProps = {
  isShow: undefined,
  closeModal: undefined
};
//# sourceMappingURL=SiteMaintenance.js.map